export default __webpack_public_path__ + "static/media/Firstmile.502eb58d.xlsx";